export default __webpack_public_path__ + "static/media/Snd_LowerDUpHigher.e577d2b2.mp3";